import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'sonner';
import { apiGet, apiPost } from '../../lib/api';

const inputCls = 'w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-rozops-blue/20 focus:border-rozops-blue';

export default function CustomerSubs() {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const [qty, setQty] = useState(0);
  const { selectedCustomerId, loadingProviders } = useOutletContext() || {};

  const providerQuery = selectedCustomerId ? `?customer_id=${selectedCustomerId}` : '';
  useEffect(() => {
    if (loadingProviders) return;
    apiGet(`/customer/subscriptions${providerQuery}`).then(r => setList(r.data || [])).catch(e => toast.error(e.message));
  }, [providerQuery, loadingProviders]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const requestCustomerId = editing.customer_id || selectedCustomerId;
      const requestQuery = requestCustomerId ? `?customer_id=${requestCustomerId}` : '';
      await apiPost(`/customer/subscriptions/${editing.id}/change-request${requestQuery}`, { quantity: Number(qty) });
      toast.success('Request sent to your vendor');
      setEditing(null);
      const res = await apiGet(`/customer/subscriptions${providerQuery}`);
      setList(res.data || []);
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div className="space-y-3" data-testid="cust-subs">
      <h1 className="font-heading font-bold text-2xl text-rozops-navy">My subscriptions</h1>
      {list.length === 0 && <div className="bg-white rounded-2xl border border-gray-100 p-6 text-center text-rozops-text-muted">No active subscriptions.</div>}
      {list.map(s => (
        <div key={s.id} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-5">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-heading font-bold text-rozops-navy">{s.product?.name}</div>
              {s.provider?.business?.business_name && <div className="text-xs text-rozops-text-muted">{s.provider.business.business_name}</div>}
              <div className="text-xs text-rozops-text-muted">{s.quantity} {s.product?.unit} · ₹{s.product?.default_price}/{s.product?.unit}</div>
            </div>
            <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${s.status === 'active' ? 'bg-rozops-green-light text-rozops-green' : 'bg-amber-50 text-amber-700'}`}>{s.status}</span>
          </div>
          <button onClick={() => { setEditing(s); setQty(s.quantity); }} data-testid={`req-change-${s.id}`} className="mt-3 text-rozops-blue text-sm font-semibold">Request quantity change</button>
        </div>
      ))}

      {editing && (
        <div className="fixed inset-0 bg-black/40 grid place-items-center p-4 z-50" onClick={() => setEditing(null)}>
          <div className="bg-white rounded-2xl shadow-medium p-6 w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-heading font-bold text-lg text-rozops-navy mb-2">Change {editing.product?.name}</h2>
            <p className="text-xs text-rozops-text-muted mb-3">Your merchant will review this request.</p>
            <form onSubmit={submit} className="space-y-3">
              <input type="number" step="0.5" min="0" className={inputCls} value={qty} onChange={(e) => setQty(e.target.value)} data-testid="req-qty" />
              <div className="flex justify-end gap-2">
                <button type="button" onClick={() => setEditing(null)} className="px-4 py-2 rounded-xl text-rozops-text-muted">Cancel</button>
                <button type="submit" className="bg-rozops-blue text-white rounded-xl px-4 py-2 font-semibold" data-testid="req-submit">Send request</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
